import { useContext } from 'react';

import { GaugeChartRangeMinContext } from '../contexts/GaugeChartRangeMinContext.js';

export const useGaugeChartRangeMinContext = () =>
  useContext(GaugeChartRangeMinContext);
